import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-form-page-loading-overlay',
  templateUrl: './form-page-loading-overlay.component.html',
  styleUrls: ['./form-page-loading-overlay.component.scss']
})
export class FormPageLoadingOverlayComponent {
  @Input()
  showHeader = true;

  @Input()
  formLinesCount = 4;

  constructor(

  ) { }


}
